import { Box, Button, Typography } from "@mui/material";
import { useEffect } from "react";

import GarageList from "../../components/GarageList";

import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { CONFIRMATION_DELAY } from "../../constants/const";
import { ItemCategory } from "../../constants/enum/enum";
import { Messages } from "../../constants/messages";
import { dispatchTxAction } from "../../helper/dispatchTxAction";
import useWallet from "../../hook/useWallet";
import {
  getGarageListAction,
  mintNewCarAction,
} from "../../reducers/game.slice";
import { toastSuccess, toUSDFormat } from "../../utils/utils";

import useStyles from "./index.styles";

const Garage = () => {
  const { classes } = useStyles();
  const dispatch = useAppDispatch();
  const { account } = useWallet();

  const { myProfile, myInventoryItems } = useAppSelector(
    (state) => state.profile
  );
  const { myGarageList } = useAppSelector((state) => state.game);

  const { signMsg, signature } = useAppSelector((state) => state.auth);

  const totalValue = myGarageList.reduce(
    (sum, myGarageList) => sum + myGarageList.car.value,
    0
  );

  const handleDepositCars = () => {
    const carItemIds = myInventoryItems
      .filter((item) => item.categoryId === ItemCategory.CAR)
      .map((item) => item.itemId);

    if (carItemIds.length === 0) {
      toastSuccess(Messages.GARAGE.CAR_DEPOSIT.NO_CAR_ITEMS);
      return;
    }

    dispatchTxAction(
      dispatch,
      mintNewCarAction({
        account,
        signMsg,
        signature,
        itemIds: carItemIds,
      }),
      () => {
        toastSuccess(Messages.GARAGE.CAR_DEPOSIT.SUCCESS);

        if (!myProfile || myProfile.city === undefined) return;

        dispatch(getGarageListAction({ account }));
      },
      CONFIRMATION_DELAY
    );
  };

  useEffect(() => {
    if (!myProfile || myProfile.city === undefined) return;

    dispatch(getGarageListAction({ account }));
  }, [dispatch, account, myProfile]);

  return (
    <Box className={classes.body}>
      <Box className={classes.container}>
        <Box className={classes.header}>
          <Box className={classes.headerLeft}>
            <Typography
              fontFamily={"Philosopher"}
              color={"white"}
              textAlign={"center"}
              fontSize={36}
              fontWeight={700}
            >
              Garage
            </Typography>
          </Box>

          <Box className={classes.headerRight}>
            <Typography
              fontFamily={"Philosopher"}
              color={"white"}
              textAlign={"center"}
              fontSize={{ xs: 12, sm: 20 }}
              fontWeight={700}
            >
              Total value:
            </Typography>
            <Box
              component={"img"}
              src={"/assets/imgs/layout/currency.png"}
              alt="Currency"
            />
            <Typography
              fontFamily={"Philosopher"}
              color={"white"}
              textAlign={"center"}
              fontSize={{ xs: 12, sm: 20 }}
              fontWeight={700}
            >
              {toUSDFormat(totalValue)}
            </Typography>

            <Typography
              fontFamily={"Philosopher"}
              color={"white"}
              textAlign={"center"}
              fontSize={{ xs: 12, sm: 20 }}
              fontWeight={700}
            >
              Total cars: {myGarageList.length}
            </Typography>

            <Button
              onClick={handleDepositCars}
              className={classes.depositButton}
            >
              Deposit cars
            </Button>
          </Box>
        </Box>

        <GarageList />
      </Box>
    </Box>
  );
};

export default Garage;
